export const DOWNLOAD_DOCUMENT_REQUEST = 'DOWNLOAD_DOCUMENT_REQUEST';

export const downloadDocumentRequest = ( id ) => ({
    type: DOWNLOAD_DOCUMENT_REQUEST,
    payload: { id }
});
